import type { BlockContentAndMedia } from 'types/block-content-and-media';
import React from 'react';
import dynamic from 'next/dynamic';
import { Button, Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const VideoYoutube = dynamic(() => import('./video-youtube'));

const ContentAndMedia: React.FC<BlockContentAndMedia> = ({
  sectionId,
  title,
  label,
  content,
  contentAlignment,
  button,
  image,
  youtubeVideoId,
  videoThumbnail,
  playButtonPosition = 'center',
  mediaLabel,
}) => {
  const leftAlignment = contentAlignment === 'left';

  return (
    <Wrap id={sectionId}>
      <div className="grid md:grid-cols-2 md:gap-x-14 gap-y-8">
        <div
          className={[
            'grid gap-y-6 max-w-lg',
            !leftAlignment ? 'justify-self-end' : 'justify-self-start',
          ].join(' ')}
        >
          {title?.length > 0 && (
            <HeadingBody
              className="text-left !mb-2"
              {...{ level: '2', title }}
            />
          )}
          {label?.length > 0 ? <p className="">{label}</p> : null}

          {content?.length > 0 ? (
            <WysiwygContent
              content={content}
              extraLargeParagraph={true}
              className={[
                '!text-lg lg:!text-2xl leafwell-add-margin-top-to-li',
              ].join(' ')}
            />
          ) : null}
        </div>
        <div
          className={[
            'order-first',
            !leftAlignment ? 'md:order-first' : 'md:order-last',
          ].join(' ')}
        >
          {image && <Figure {...image} />}
          {youtubeVideoId && (
            <VideoYoutube
              youtubeVideos={Array({
                youtubeVideoId: youtubeVideoId,
                image: videoThumbnail,
                playButtonStyle:
                  playButtonPosition === 'center' ? 'secondary' : 'tertiary',
              })}
              videoSize="large"
              variant="none"
              sectionId=""
              removePadding={true}
            />
          )}
          {mediaLabel?.length > 0 ? (
            <p className="text-sm mt-4">{mediaLabel}</p>
          ) : null}
        </div>
        {button && (
          <span
            className={
              !leftAlignment
                ? 'md:col-start-2 xl:w-[32rem] xl:justify-self-end'
                : ''
            }
          >
            <Button
              href={button.url}
              label={button.title}
              rounded={true}
              filled={false}
              variant="secondary"
              target={button.target}
              className="w-full md:w-fit h-fit"
            />
          </span>
        )}
      </div>
    </Wrap>
  );
};

export default ContentAndMedia;
